import React from "react";
import PolicyPage from "./PolicyPage";
import { STORE } from "../config/store";

const sections = [
  {
    title: "What is being sold",
    paragraphs: [`${STORE.brand} offers the physical goods shown in its catalogue, with the title, price, available variant, stock state, dimensions, materials, use and care information recorded on each item page. A basket is a working list and does not reserve stock.`],
  },
  {
    title: "Order formation",
    paragraphs: ["Selecting Pay Now submits the validated email, delivery address, order reference and total to the hosted payment flow. It is an offer to purchase, not proof of acceptance or settlement. An order is accepted only after payment is independently confirmed and the selected goods remain available for fulfilment."],
  },
  {
    title: "Price and order total",
    paragraphs: [`Catalogue prices, basket figures and the payment request are denominated in ${STORE.currency}. The payable amount is the merchandise subtotal plus the fixed ${STORE.currency} ${STORE.shippingFee.toFixed(2)} delivery charge. A corrected total or obvious display error must be raised before acceptance; no higher amount may be substituted without the customer's agreement.`],
  },
  {
    title: "Stock and verification",
    paragraphs: ["Acceptance pauses when independent payment confirmation is absent, essential destination details remain incomplete, chosen stock has run out or transaction signals justify a security review. Money already captured for merchandise the store cannot supply is sent back using the payment route from which it came."],
  },
  {
    title: "Selected product and variations",
    paragraphs: ["The chosen colour, size and quantity shown in the order record form part of the purchase. Screen rendition and normal material or batch variation are addressed in the product-information policy; neither permits delivery of a materially different product."],
    links: [["Product Descriptions & Variation", "/product-information"]],
  },
  {
    title: "Delivery, cancellation and remedies",
    paragraphs: ["Shipping & Delivery controls the destination details and fixed charge. An order can be cancelled only before its processing becomes irreversible. For breakage, danger, a material mismatch, a fault or the wrong item, the returns page supplies the evidence route and resolution steps. These terms leave every non-excludable consumer protection intact."],
    links: [["Shipping & Delivery", "/shipping"], ["Order Cancellation", "/order-cancellation"], ["Returns, Refunds & Exchanges", "/returns"]],
  },
];

export default function TermsOfSale() {
  return <PolicyPage title="Terms of Sale" intro="How a basket becomes an accepted order and which facts make up the purchase." sections={sections} related={[["Payment, Pricing & Fraud", "/payment-pricing"], ["Sale & Clearance", "/sale-clearance"]]} />;
}
